import { auth } from './metas'
const Customization = () => import('@/pages/Customization')
const Links = () => import('@/pages/Links')

export default [
  {
    path: '/customization',
    name: 'Customization',
    component: Customization,
    meta: auth
  },
  {
    path: '/smart-link',
    name: 'Links',
    component: Links,
    meta: auth
  }
]



// WEBPACK FOOTER //
// ./src/router/customizations.route.js